// The server actions this page ports each answered `{ success: false, error }` with one
// message; the Rails ports redirect with `inertia: { errors: { base: <message> } }`.
// `types/globals.d.ts` declares Inertia's error values as `string[]`, so the cast is the
// same one every other ported form does (pages/Admin/Reviewers/AddReviewerDialog).
export function baseError(errors: unknown): string | undefined {
  return (errors as Record<string, string | undefined>).base;
}
